import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { SiteGridContainer } from '../../containers/assignEntities/SiteGridContainer';
import { UserGridContainer } from '../../containers/assignEntities/UserGridContainer';

const AssignUserToSites = props => {
  const {
    allUsersData,
    loadingAllUsers,
    allSitesData,
    loadingAllSites,
    setIsReadOnlyState,
    isReadOnly,
    onResetPageOnDataChange,
    resetGridPage,
    onFilteredChange,
    rightSideGridReactTableRef,
    isRightGridFiltered,
  } = props;

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={6}>
          <Field
            component={UserGridContainer}
            name={AssignEntitiesEnum.UserGridInfo}
            {...{
              dataSource: allUsersData,
              loadingAllUsers,
              isLeftSideUserGrid: true,
              isRightSideSiteGrid: true,
              allSitesData,
              setIsReadOnlyState,
              isReadOnly,
              onResetPageOnDataChange,
              resetGridPage,
            }}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <Field
            component={SiteGridContainer}
            name={AssignEntitiesEnum.SiteGridInfo}
            {...{
              dataSource: allSitesData,
              loadingAllSites,
              isLeftSideUserGrid: true,
              isRightSideSiteGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              onFilteredChange,
              rightSideGridReactTableRef,
              isRightGridFiltered,
              onResetPageOnDataChange,
              resetGridPage,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignUserToSites.propTypes = {
  allUsersData: PropTypes.array.isRequired,
  allSitesData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  setIsReadOnlyState: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  loadingAllUsers: PropTypes.bool,
  loadingAllSites: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
  isRightGridFiltered: PropTypes.bool,
};

AssignUserToSites.defaultProps = {
  loadingAllUsers: false,
  loadingAllSites: false,
  isReadOnly: true,
  isRightGridFiltered: false,
  rightSideGridReactTableRef: null,
  setIsReadOnlyState: () => {},
  onResetPageOnDataChange: () => {},
  onFilteredChange: () => {},
};
export default AssignUserToSites;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/assignEntities/AssignUserToSites.js